/**
 * Contact.
 *
 * The landing footer has linked to /contact since before there was one, and a
 * health product that publishes no way to reach a human does not pass app-store
 * review. The addresses are the ones in legalDetails.ts, so they cannot drift
 * apart from the imprint.
 */

import { LEGAL } from "./legalDetails";
import { LegalPageLayout, LegalSection } from "./LegalPageLayout";

export function ContactPage() {
  const { contact, operator } = LEGAL;

  const mailto = (address: string) => (
    <a className="text-primary-600 hover:underline" href={`mailto:${address}`}>
      {address}
    </a>
  );

  return (
    <LegalPageLayout
      title="Contact"
      subtitle="Who to write to, and what to expect back."
      description="How to reach HealthPass: support, privacy and data protection, billing questions, and security reports."
      path="/contact"
    >
      <LegalSection number={1} heading="Support">
        <p>
          Anything about using the app, your account or your subscription:{" "}
          {mailto(contact.general)}. We answer within two working days;
          subscribers on a paid plan come first.
        </p>
      </LegalSection>

      <LegalSection number={2} heading="Privacy and your data">
        <p>
          Access, correction, export or deletion of your data, and any question
          about how it is processed: {mailto(contact.privacy)}. You do not have
          to write to us to export or delete — both are in your settings — but
          we answer within the one month Article 12(3) GDPR allows.
        </p>
        <p>Data protection contact: {mailto(contact.dpo)}.</p>
      </LegalSection>

      <LegalSection number={3} heading="Reporting a security problem">
        <p>
          If you have found a vulnerability, write to {mailto(contact.general)}{" "}
          with &ldquo;security&rdquo; in the subject and we will come back to you
          within two working days. Please give us a reasonable period to fix it
          before you publish, and do not access, alter or keep other
          people&rsquo;s data while investigating &mdash; this is health data.
        </p>
      </LegalSection>

      <LegalSection number={4} heading="Postal address">
        <p>
          {operator.name}
          <br />
          {operator.street}
          <br />
          {operator.city}
          <br />
          {operator.country}
        </p>
        <p>
          Travellers in the EU may write to our representative in the Union
          instead — it is named in the Imprint.
        </p>
      </LegalSection>

      <LegalSection number={5} heading="In an emergency">
        <p>
          HealthPass is not an emergency service and nobody here is monitoring
          your health data. If you need urgent medical help, call your local
          emergency number.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}

export default ContactPage;
